// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DeleteAltenratesConfirmationModalQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  locationId: Types.Scalars['ID']['input'];
}>;


export type DeleteAltenratesConfirmationModalQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, name: string, readyPlanLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, name: string, location: { __typename?: 'Location', id: string } }> } };

export type DeleteDpAlternateRplMutationVariables = Types.Exact<{
  altRplId: Types.Scalars['ID']['input'];
}>;


export type DeleteDpAlternateRplMutation = { __typename?: 'Mutation', deleteDesignPackageAlternateLocation: { __typename: 'SaveDesignPackageLocationPlanMappingsResult' } };


export const DeleteAltenratesConfirmationModalDocument = gql`
    query DeleteAltenratesConfirmationModal($designPackageId: ID!, $locationId: ID!) {
  designPackage(id: $designPackageId) {
    id
    name
    readyPlanLocations(filter: {alternatesToLocationId: $locationId}) {
      id
      name
      location {
        id
      }
    }
  }
}
    `;

/**
 * __useDeleteAltenratesConfirmationModalQuery__
 *
 * To run a query within a React component, call `useDeleteAltenratesConfirmationModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteAltenratesConfirmationModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteAltenratesConfirmationModalQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useDeleteAltenratesConfirmationModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables> & ({ variables: DeleteAltenratesConfirmationModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>(DeleteAltenratesConfirmationModalDocument, options);
      }
export function useDeleteAltenratesConfirmationModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>(DeleteAltenratesConfirmationModalDocument, options);
        }
// @ts-ignore
export function useDeleteAltenratesConfirmationModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>;
export function useDeleteAltenratesConfirmationModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeleteAltenratesConfirmationModalQuery | undefined, DeleteAltenratesConfirmationModalQueryVariables>;
export function useDeleteAltenratesConfirmationModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>(DeleteAltenratesConfirmationModalDocument, options);
        }
export type DeleteAltenratesConfirmationModalQueryHookResult = ReturnType<typeof useDeleteAltenratesConfirmationModalQuery>;
export type DeleteAltenratesConfirmationModalLazyQueryHookResult = ReturnType<typeof useDeleteAltenratesConfirmationModalLazyQuery>;
export type DeleteAltenratesConfirmationModalSuspenseQueryHookResult = ReturnType<typeof useDeleteAltenratesConfirmationModalSuspenseQuery>;
export type DeleteAltenratesConfirmationModalQueryResult = ApolloReactCommon.QueryResult<DeleteAltenratesConfirmationModalQuery, DeleteAltenratesConfirmationModalQueryVariables>;
export const DeleteDpAlternateRplDocument = gql`
    mutation DeleteDpAlternateRpl($altRplId: ID!) {
  deleteDesignPackageAlternateLocation(altRplId: $altRplId) {
    __typename
  }
}
    `;

/**
 * __useDeleteDpAlternateRplMutation__
 *
 * To run a mutation, you first call `useDeleteDpAlternateRplMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDpAlternateRplMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDpAlternateRplMutation, { data, loading, error }] = useDeleteDpAlternateRplMutation({
 *   variables: {
 *      altRplId: // value for 'altRplId'
 *   },
 * });
 */
export function useDeleteDpAlternateRplMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDpAlternateRplMutation, DeleteDpAlternateRplMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDpAlternateRplMutation, DeleteDpAlternateRplMutationVariables>(DeleteDpAlternateRplDocument, options);
      }
export type DeleteDpAlternateRplMutationHookResult = ReturnType<typeof useDeleteDpAlternateRplMutation>;
export type DeleteDpAlternateRplMutationResult = ApolloReactCommon.MutationResult<DeleteDpAlternateRplMutation>;